import { DateTime } from 'luxon';
import { GAME_HISTORY_DEFAULT_FIELDS, LAST_24_HOURS_VALUE } from './constants';

export const parseCms = (data) => {
    const {
        showPerPage = true,
        productCasino = false,
        showCurrentRage = true,
        productSportsbook = true,
        anotherPeriodEnabled = true,
        consolidateBonusRounds = false,
        fields = GAME_HISTORY_DEFAULT_FIELDS,
        paginationOptions = [{ value: 5 }, { value: 25 }, { value: 50 }],
        ...rest
    } = data;

    return {
        fields,
        showPerPage,
        productCasino,
        showCurrentRage,
        productSportsbook,
        paginationOptions,
        anotherPeriodEnabled,
        consolidateBonusRounds,
        ...rest
    };
};

export const intoDate = date => typeof date === 'number' ? new Date(date) : date;

export const startOfDay = (date = new Date()) => {
    const anotherDate = new Date(date.valueOf());

    anotherDate.setHours(0, 0, 0, 0);

    return anotherDate;
};

export const endOfDay = (date = new Date()) => {
    const anotherDate = new Date(date.valueOf());

    anotherDate.setHours(23, 59, 59, 0);

    return anotherDate;
};

export const getInitialPeriodData = () => {
    const currentDate = DateTime.local();
    const days = LAST_24_HOURS_VALUE;

    return {
        period: days,
        startDate: currentDate.minus({ days }).toJSDate(),
        endDate: currentDate.toJSDate()
    };
};
